(function () {
  'use strict';
  const endpoint = 'https://member.zaaguk.com/api/login-pin?__zaag_route=member-pricing';
  let verified = false;
  let statusPromise;
  let checkoutPromise;
  let queued = false;

  async function pricing(action) {
    const response = await fetch(endpoint, {
      method: 'POST', credentials: 'include', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action }), signal: AbortSignal.timeout(15000)
    });
    const result = await response.json();
    if (response.status === 401) return { member: false, authenticated: false };
    if (!response.ok || result.success !== true) throw new Error(result.message || 'Unable to check member pricing.');
    return result;
  }

  function renderPrices() {
    document.documentElement.classList.toggle('zaag-member-logged-in', verified);
    document.querySelectorAll('[data-zaag-member-price]').forEach(element => {
      if (element.hidden === verified) element.hidden = !verified;
    });
  }

  async function checkStatus() {
    if (statusPromise) return statusPromise;
    statusPromise = (async () => {
      try {
        const result = await pricing('member_price_status');
        verified = result.authenticated === true && result.member === true &&
          Number(result.discount_percent) === 80 && Number(result.price_multiplier) === 0.2;
        renderPrices();
        return verified;
      } catch (error) {
        verified = false;
        renderPrices();
        throw error;
      } finally { statusPromise = null; }
    })();
    return statusPromise;
  }

  async function checkout() {
    if (checkoutPromise) return checkoutPromise;
    checkoutPromise = (async () => {
      try {
        if (!await checkStatus()) {
          window.location.assign('/checkout');
          return;
        }
        const result = await pricing('member_checkout_discount');
        if (!result.authenticated || !result.member || !result.discount_code) {
          throw new Error('Please sign in again to use your member price.');
        }
        const response = await fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { zaag_member_code: result.member_code } })
        });
        if (!response.ok) throw new Error('Unable to prepare your cart. Please try again.');
        window.location.assign('/discount/' + encodeURIComponent(result.discount_code) + '?redirect=/checkout');
      } catch (error) {
        alert(error.message || 'Unable to prepare member checkout. Please try again.');
      } finally { checkoutPromise = null; }
    })();
    return checkoutPromise;
  }
  window.ZaagMemberPricing = { checkout, refresh: checkStatus };

  document.addEventListener('click', event => {
    const control = event.target.closest('a[href], button[name="checkout"], input[name="checkout"]');
    if (!control) return;
    let checkoutLink = false;
    if (control.tagName === 'A') {
      const url = new URL(control.href, window.location.href);
      checkoutLink = url.origin === window.location.origin && /\/checkout\/?$/.test(url.pathname);
    }
    if (!checkoutLink && control.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void checkout();
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void checkout();
  }, true);

  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; renderPrices(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => { void checkStatus().catch(console.error); });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) void checkStatus().catch(console.error);
  });
  void checkStatus().catch(console.error);
})();
